import IdPreference from "./IdPreference";

export default IdPreference;
